export default __webpack_public_path__ + "static/media/translate.14e84d83.svg";